import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=1a7c9719"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports